import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const TruckLarge = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M18.398 9.766A3.2 3.2 0 0 0 16.29 8.75 1.25 1.25 0 0 0 15 10v3.75h-1.25v-10c0-.703-.547-1.25-1.25-1.25H1.25C.547 2.5 0 3.047 0 3.75V15c0 .703.547 1.25 1.25 1.25a2.5 2.5 0 0 0 5 0h7.5a2.5 2.5 0 0 0 5 0c.703 0 1.25-.547 1.25-1.25 0-2.383-.547-4.18-1.602-5.234m-3.032 7.368a1.25 1.25 0 1 0 1.768-1.768 1.25 1.25 0 0 0-1.768 1.768m-12.5 0a1.25 1.25 0 1 0 1.768-1.768 1.25 1.25 0 0 0-1.768 1.768" }) }));
});
TruckLarge.displayName = 'TruckLarge';
TruckLarge.__iconComponentType = 'standard';
export default TruckLarge;
//# sourceMappingURL=TruckLarge.js.map